'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  height: 8px;\n'], ['\n  height: 8px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 8px;\n  width: 100%;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 8px;\n  width: 100%;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  margin-top: 4px;\n  height: 20px;\n'], ['\n  margin-top: 4px;\n  height: 20px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  margin-top: 4px;\n'], ['\n  margin-top: 4px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  ', '\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  ', '\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  margin-left: 6px;\n'], ['\n  margin-left: 6px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Text = require('../../fundamentals/Text');

var _Text2 = _interopRequireDefault(_Text);

var _View = require('../../atoms/View');

var _View2 = _interopRequireDefault(_View);

var _Input = require('../../atoms/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Link = require('../../atoms/Link');

var _Link2 = _interopRequireDefault(_Link);

var _isFunction = require('../../../util/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _proptypes = require('./proptypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VerticalSpacer = (0, _styledComponents2.default)(_View2.default)(_templateObject);

var Content = (0, _styledComponents2.default)(_View2.default)(_templateObject2);

var ErrorPlaceHolder = (0, _styledComponents2.default)(_View2.default)(_templateObject3);

var ErrorPlaceHolderWithoutHeight = (0, _styledComponents2.default)(_View2.default)(_templateObject4);

var FormLabelContent = (0, _styledComponents2.default)(_View2.default)(_templateObject5, function (props) {
  return props.withCallout ? 'justify-content: space-between;' : '';
});

var TipWrapper = (0, _styledComponents2.default)(_View2.default)(_templateObject6);

/* eslint-disable */
var CalloutLink = function CalloutLink(props) {
  return _react2.default.createElement(
    _Link2.default,
    {
      type: 'primary',
      underline: props.linkUnderline,
      href: props.href,
      tabIndex: -1
    },
    props.children
  );
};

var FormLabel = function FormLabel(props) {
  var withCallout = props.withCallout,
      href = props.href,
      linkUnderline = props.linkUnderline;

  return _react2.default.createElement(
    FormLabelContent,
    { withCallout: withCallout },
    _react2.default.createElement(
      _Text2.default,
      { weight: 'bold', size: 'body1' },
      props.label
    ),
    _react2.default.createElement(
      TipWrapper,
      null,
      withCallout ? _react2.default.createElement(
        CalloutLink,
        { linkUnderline: linkUnderline, href: href },
        props.text
      ) : _react2.default.createElement(
        _Text2.default,
        { color: 'grayscale.darker', size: 'caption' },
        props.text
      )
    )
  );
};
/* eslint-enable */

var formItem = function formItem(props) {
  var label = props.label,
      text = props.text,
      placeholder = props.placeholder,
      hasError = props.hasError,
      error = props.error,
      onChange = props.onChange,
      onBlur = props.onBlur,
      value = props.value,
      maxLength = props.maxLength,
      children = props.children,
      disabled = props.disabled,
      withCallout = props.withCallout,
      linkUnderline = props.linkUnderline,
      href = props.href,
      icon = props.icon,
      style = props.style,
      mask = props.mask,
      testID = props.testID,
      accessibilityLabel = props.accessibilityLabel,
      errorPlaceHolderWihoutHeight = props.errorPlaceHolderWihoutHeight,
      type = props.type;


  var childProps = {
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    hasError: hasError,
    placeholder: placeholder,
    disabled: disabled,
    testID: testID,
    accessibilityLabel: accessibilityLabel,
    type: type
  };

  childProps = (0, _keys2.default)(childProps).reduce(function (acc, key) {
    if (childProps[key]) acc[key] = childProps[key];
    return acc;
  }, {});

  return _react2.default.createElement(
    Content,
    { style: style },
    _react2.default.createElement(FormLabel, {
      label: label,
      text: text,
      withCallout: withCallout,
      href: href,
      linkUnderline: linkUnderline
    }),
    _react2.default.createElement(VerticalSpacer, null),
    children ? _react2.default.cloneElement(children, childProps) : _react2.default.createElement(_Input2.default, {
      type: type,
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      hasError: hasError,
      placeholder: placeholder,
      maxLength: maxLength,
      disabled: disabled,
      icon: icon,
      mask: mask,
      testID: testID,
      accessibilityLabel: accessibilityLabel
    }),
    errorPlaceHolderWihoutHeight ? _react2.default.createElement(
      ErrorPlaceHolderWithoutHeight,
      null,
      hasError && ((0, _isFunction2.default)(error) ? error() : _react2.default.createElement(
        _Text2.default,
        { color: 'red', size: 'caption' },
        error
      ))
    ) : _react2.default.createElement(
      ErrorPlaceHolder,
      null,
      hasError && ((0, _isFunction2.default)(error) ? error() : _react2.default.createElement(
        _Text2.default,
        { color: 'red', size: 'caption' },
        error
      ))
    )
  );
};

formItem.defaultProps = _proptypes.defaultProps;
formItem.propTypes = _proptypes.propTypes;

exports.default = formItem;